/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import util from './util.js';
import h from "../util/dom-builder.js";
import birdata from "../api.js";

function joinBookingURL(bookingCode) {
	return util.resolveURL('/book-site?code=' + bookingCode);
}

function eventPageURL(eventCode) {
	var url = (location.hostname == "localhost") ? "/event?event=" + eventCode : "/event/" + eventCode;
	return util.resolveURL(url);
}

function bookingCodeEmailURI(params) {
	var googleMapsLine = '';
	if(params.googleMapsURL) {
		googleMapsLine = 'View on Google maps: ' + params.googleMapsURL;
	}

	var subject = "Invitation to join my Birdata site booking";
	var body = `Hi,

	I am inviting you to join my Birdata site booking.

	Event: ${params.eventName}
	Date: ${util.formatDate(params.bookingDate)}
	Site: ${params.siteName}
	Booking code: ${params.bookingCode}
	${googleMapsLine}


	Please click the following link to view and join this booking: ${joinBookingURL(params.bookingCode)}
	`;

	return 'mailto:?' + util.encodeParams({
		to: '',
		subject: subject,
		body: body
	});
}

function showRegistrationPopup(event, confirmCallback) {
	var messageLines = ["By registering for this event I agree to receive email communications from BirdLife about this event."];
	var quizRequired = !!event.quiz;
	if(quizRequired) {
		messageLines.push("I understand that to participate I will need to complete the required quiz and book a site.");
	} else {
		messageLines.push("I understand that to participate I will need to book a site.");
	}

	function onClose() {
		dialog.parentElement.removeChild(dialog);

		if(dialog.returnValue === 'confirm' && confirmCallback) {
			confirmCallback();
		}
	}

	var dialog = h('dialog', { $close: onClose }, [
		h('form', { 'method': 'dialog' }, [
			h('h1', 'Confirm Registration'),
			messageLines.map(m => h('p', m)),
			h('div', { 'class': 'buttons' }, [
				h('button', { 'value': 'dismiss', 'class': 'button' }, 'Cancel'),
				h('button', { 'value': 'confirm', 'class': 'button primary' }, 'Confirm')
			])
		].flat())
	]);

	// Container for styling
	var container = h('div', { 'class': 'birdata-embed' }, dialog);

	window.document.body.appendChild(container);
	dialog.showModal();
}

function showCancelRegistrationPopup(event, confirmCallback) {
	function onClose() {
		dialog.parentElement.removeChild(dialog);

		if(dialog.returnValue === 'confirm' && confirmCallback) {
			confirmCallback();
		}
	}

	var dialog = h('dialog', { $close: onClose }, [
		h('form', { 'method': 'dialog' }, [
			h('h1', 'Cancel Registration'),
			h('p', 'Are you sure you wish to cancel your registration for this event?'),
			h('ul', [
				h('li', 'You will be unsubscribed from email communications from BirdLife about this event.'),
				h('li', 'If you have booked a site (and are listed as ‘organiser’) your booking will be cancelled for you and anyone else who has joined the booking.'),
				h('li', 'If you have joined a site using a booking code, you will be removed from all your site bookings.')
			]),
			h('div', { 'class': 'buttons' }, [
				h('button', { 'value': 'dismiss', 'class': 'button' }, 'No'),
				h('button', { 'value': 'confirm', 'class': 'button primary' }, 'Yes, I am sure')
			])
		].flat())
	]);

	// Container for styling
	var container = h('div', { 'class': 'birdata-embed' }, dialog);

	window.document.body.appendChild(container);
	dialog.showModal();
}

function showExternalQuizPopup(event, confirmCallback) {
	function onClose() {
		dialog.parentElement.removeChild(dialog);
	}

	function confirmPassed(evt) {
		evt.preventDefault();

		confirmButton.setAttribute('disabled', 'disabled');
		confirmButton.textContent = "Updating…";

		birdata.submitQuizResult({
			quiz: event.quiz,
			duration_in_seconds: 0,
			score: 0,
			passed: true
		}).then(function() {
			dialog.parentElement.removeChild(dialog);
			if(confirmCallback) {
				confirmCallback();
			}
		}).catch(function() {
			alert('There was a problem updating your information');
		}).finally(function() {
			confirmButton.setAttribute('disabled', null);
			confirmButton.textContent = 'I have passed the quiz';
		});
	}

	var confirmButton = h('button', {
		'value': 'confirm',
		'class': 'button primary',
		'$click': confirmPassed }, 'I have passed the quiz');

	var dialog = h('dialog', { $close: onClose }, [
		h('form', { 'method': 'dialog' }, [
			h('h1', 'Take Quiz'),
			h('p', 'The quiz for this event is hosted on the BNB Hub website. Clicking the link below will open the BNB Hub website in a new tab. Once you have completed the quiz, return back to this tab and confirm that you have passed the quiz.'),
			h('p',
				h('a',
					{ href: 'https://beachvol.birdlife.org.au', target: '_blank' },
					'Click here to take the the quiz on the BNB Hub website')),
			h('div', { 'class': 'buttons' }, [
				h('button', { 'value': 'dismiss', 'class': 'button' }, 'Cancel'),
				confirmButton
			])
		].flat())
	]);

	// Container for styling
	var container = h('div', { 'class': 'birdata-embed' }, dialog);

	window.document.body.appendChild(container);
	dialog.showModal();
}

export {
	bookingCodeEmailURI,
	joinBookingURL,
	eventPageURL,
	showRegistrationPopup,
	showCancelRegistrationPopup,
	showExternalQuizPopup
};
